import React from 'react';
import styles from './KanbanColumn.module.css';

export interface KanbanColumnProps<T> {
  id: string;
  title: string;
  items: T[];
  renderCard: (item: T) => React.ReactNode;
  headerClassName?: string;
  emptyMessage?: string;
  emptyState?: React.ReactNode;
  variant?: 'application' | 'interview';
}

export const KanbanColumn = <T extends { id: string }>({
  id,
  title,
  items,
  renderCard,
  headerClassName,
  emptyMessage = 'No items in this stage.',
  emptyState,
  variant = 'application',
}: KanbanColumnProps<T>) => {
  const columnClass = variant === 'interview' ? styles.kanbanColumnInterview : styles.kanbanColumnApplication;

  return (
    <div className={`${styles.kanbanColumn} ${columnClass}`}>
      <div className={`${styles.kanbanColumnHeader} ${headerClassName || ''}`}>
        <h3 className={styles.kanbanColumnTitle}>
          {title} ({items.length})
        </h3>
      </div>
      <div className={styles.kanbanColumnBody}>
        {items.length > 0 ? (
          items.map((item) => (
            <div key={item.id} className={styles.candidateCardWrapper}>
              {renderCard(item)}
            </div>
          ))
        ) : (
          emptyState || <p className={styles.kanbanColumnEmptyText}>{emptyMessage}</p>
        )}
      </div>
    </div>
  );
};
